"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Display", {
    enumerable: true,
    get: function() {
        return Display;
    }
});
const _createPreset = require("../createPreset");
const _useDisplayStylesstyles = require("./useDisplayStyles.styles");
const Display = (0, _createPreset.createPreset)({
    useStyles: _useDisplayStylesstyles.useDisplayStyles,
    className: _useDisplayStylesstyles.displayClassNames.root,
    displayName: 'Display'
});
